export default {
    name: 'Имя',
    tel: 'телефон',
    save: 'спасти',
    confirm: 'подтверждать',
    cancel: 'Отмена',
    delete: 'удалять',
    complete: 'Заканчивать',
    loading: 'Загрузка...',
    telEmpty: 'Пожалуйста, заполните номер телефона',
    nameEmpty: 'Пожалуйста, заполните ваше имя',
    nameInvalid: 'Пожалуйста, введите верное имя',
    confirmDelete: 'Вы уверены, что хотите удалить',
    telInvalid: 'Пожалуйста, введите правильный номер телефона',
    vanCalendar: {
        end: 'конец',
        start: 'Начинать',
        title: 'заглавие',
        confirm: 'подтверждать',
        startEnd: 'начать конец',
        weekdays: ['День', 'Раз', 'Два', 'Три', 'Четыре', 'Пять', 'Шесть'],
    },
    vanCascader: {
        select: 'пожалуйста, выберите',
    },
    vanContactCard: {
        addText: 'Добавить контакты',
    },
    vanContactList: {
        addText: 'новый контакт',
    },
    vanPagination: {
        prev: 'Предыдущая страница',
        next: 'следущая страница',
    },
    vanPullRefresh: {
        pulling: 'Потяните вниз, чтобы обновить...',
        loosing: 'выпустить обновление...',
    },
    vanSubmitBar: {
        label: 'все:',
    },
    vanCoupon: {
        unlimited: 'нет ограничений по использованию',
    },
    vanCouponCell: {
        title: 'купон',
        tips: 'Недоступно',
    },
    vanCouponList: {
        empty: 'нет купона',
        exchange: 'обмен',
        close: 'нет купона',
        enable: 'годный к употреблению',
        disabled: 'Недоступно',
        placeholder: 'Пожалуйста, введите промо-код',
    },
    vanAddressEdit: {
        area: 'площадь',
        postal: 'почтовый индекс',
        areaEmpty: 'выберите регион',
        addressEmpty: 'Пожалуйста, заполните подробный адрес',
        postalEmpty: 'Неверный формат почтового индекса',
        defaultAddress: 'Сделать адрес доставки по умолчанию',
        telPlaceholder: 'Номер мобильного телефона грузополучателя',
        namePlaceholder: 'Имя грузополучателя',
        areaPlaceholder: 'Выберите провинцию/город/регион',
    },
    vanAddressEditDetail: {
        label: 'адрес',
        placeholder: 'Номер улицы, этаж, номер комнаты и т.д.',
    },
    vanAddressList: {
        add: 'добавить адрес',
    },
};
